"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _UIAbstractPageTemplate = _interopRequireDefault(require("./UIAbstractPageTemplate"));

function UIListingPage(props) {
  return _react.default.createElement(_UIAbstractPageTemplate.default, Object.assign({}, props, {
    horizontalDivider: true
  }));
}

UIListingPage.propTypes = (0, _omit.default)(_UIAbstractPageTemplate.default.propTypes, 'horizontalDivider');
UIListingPage.defaultProps = (0, _omit.default)(_UIAbstractPageTemplate.default.defaultProps, 'horizontalDivider');
UIListingPage.displayName = 'UIListingPage';
var _default = UIListingPage;
exports.default = _default;
module.exports = exports.default;